<template>
  <div class="pointsrule" v-loading="loading">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="300px"
      class="config-form"
    >
      <el-form-item label="1:1兑换积分上限" prop="limitPoints">
        <el-input v-model="formData.limitPoints" placeholder="请输入积分上限" />
      </el-form-item>
      <el-form-item label="超过部分兑换积分比例（本地积分：积分）" prop="localToPoints">
        <el-input v-model="formData.localToPoints" placeholder="请输入本地积分到积分比例" />
      </el-form-item>
      <el-form-item label="超过部分兑换D币比例（本地积分：D币）" prop="localToCoins">
        <el-input v-model="formData.localToCoins" placeholder="请输入本地积分到D币比例" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSave" :loading="saving">
          保存配置
        </el-button>
        <el-button @click="handleReset" :loading="resetting">
          重置为默认
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { PointsRuleSpe } from '@/api';

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);

const formData = reactive<PointsRuleSpe>({
  localToPoints: '',
  localToCoins: '',
  limitPoints: '',
});

// 正数正则（可保留2位小数）
const positiveNumberPattern = /^\d+:\d+$/u;

const rules: FormRules = {
  localToPoints: [
    { required: true, message: '请输入本地到积分比例', trigger: 'change' },
    { pattern: positiveNumberPattern, message: '请输入正确的比例，格式为：x:x', trigger: 'change' },
  ],
  localToCoins: [
    { required: true, message: '请输入本地到D币比例', trigger: 'change' },
    { pattern: positiveNumberPattern, message: '请输入正确的比例，格式为：x:x', trigger: 'change' },
  ],
  limitPoints: [
    { required: true, message: '请输入积分上限', trigger: 'change' },
    { pattern: /^\d+$/u, message: '请输入正整数', trigger: 'change' },
  ],
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().pointsRuleApi.getPointsRulepointsRule();
    const { data } = res.data;
    if (data) {
      formData.localToPoints = data.localToPoints || '';
      formData.localToCoins = data.localToCoins || '';
      formData.limitPoints = data.limitPoints || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().pointsRuleApi.setPointsRulepointsRule({
      rule: formData,
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().pointsRuleApi.resetPointsRulepointsRule();
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
